import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import PageSEO from './components/PageSEO';
import './App.css';

// Sections
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import NextChapterSection from './components/NextChapterSection';
import CapabilitiesSection from './components/CapabilitiesSection';
import ColdWeatherBanner from './components/ColdWeatherBanner';
import ComplianceSection from './components/ComplianceSection';
import HeroProductsSection from './components/HeroProductsSection';
import GovernmentSection from './components/GovernmentSection';
import BrandPortfolioSection from './components/BrandPortfolioSection';
import ManufacturingSection from './components/ManufacturingSection';
import SustainabilityPreview from './components/SustainabilityPreview';
import PeoplePreview from './components/PeoplePreview';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import AdminPanel from './components/AdminPanel';
import InvestorRelations from './components/InvestorRelations';

// Full pages
import MaterialsPage from './components/MaterialsPage';
import PeoplePage from './components/PeoplePage';
import SustainabilityPage from './components/SustainabilityPage';

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        const el = document.getElementById(location.state.scrollTo);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 300);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <>
      <PageSEO path="/" />
      <Navigation />
      <main>
        <HeroSection />
        <AboutSection />
        <NextChapterSection />
        <ComplianceSection />
        <CapabilitiesSection />
        <ColdWeatherBanner />
        <HeroProductsSection />
        <GovernmentSection />
        <BrandPortfolioSection />
        <ManufacturingSection />
        <SustainabilityPreview />
        <PeoplePreview />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/materials" element={<MaterialsPage />} />
        <Route path="/people" element={<PeoplePage />} />
        <Route path="/sustainability" element={<SustainabilityPage />} />
        <Route path="/investor-relations" element={<InvestorRelations />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
